import { Component, OnInit, Input, Output, EventEmitter,ChangeDetectionStrategy  } from '@angular/core';

@Component({
  selector: 'show-task',
  templateUrl: './show-task.component.html',
  styleUrls: ['./show-task.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShowTaskComponent implements OnInit {
  @Input() detail: any;
  @Input() show: boolean;
  @Output() reset: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor() { }

  ngOnInit() {
  }
  closeDetail(evt) {
    this.reset.emit(false);
    evt.stopPropagation();

  }
}



// WEBPACK FOOTER //
// ./src/app/section/appointment/calendar/show-task.component.ts